import { render, staticRenderFns } from "./object-picker.vue?vue&type=template&id=30d72cf4&scoped=true&"
import script from "./object-picker.vue?vue&type=script&lang=js&"
export * from "./object-picker.vue?vue&type=script&lang=js&"
import style0 from "./object-picker.vue?vue&type=style&index=0&id=30d72cf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d72cf4",
  null
  
)

export default component.exports